export const en = {
    balance_invoice: 'Account refill',
    can_download: 'You can download the invoice and pay it',
    amount: 'Deposit amount',
    download: 'Download the invoice',
};
